import React from 'react';
import { Search } from 'lucide-react';
interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}
export function SearchBar({
  value,
  onChange,
  placeholder = 'Search employees...'
}: SearchBarProps) {
  return <div className="relative w-full" data-id="element-131">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-132">
        <Search size={18} data-id="element-133" />
      </div>
      <input type="text" value={value} onChange={e => onChange(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-slate-200 rounded-lg leading-5 bg-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 sm:text-sm shadow-sm" placeholder={placeholder} data-id="element-134" />
    </div>;
}